module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.14/frontend/_next/static/images/RuStoreText-adeef037d09044bd22be5b2c947dc375.svg";